// extracted by mini-css-extract-plugin
var _1 = "jbsfiz9pOu3Nm3Qzarpw";
var _2 = "Kue4HaU5aXQYS_FwN4Fk";
var _3 = "q_Q2MPPEuAYNzFJl4voC";
var _4 = "EuEjfSj3OzVZDrvOpLdB";
var _5 = "eljL9TG6CvbhmYzVMTCh";
var _6 = "ZZ_9fKlyINjlJoVsPlTV";
export { _1 as "formMargin", _2 as "imageStyle", _3 as "images", _4 as "mobilePage", _5 as "page", _6 as "pageHeight" }
